import React, { useEffect, useState } from "react";
import { getGrievancesApi, getProfileApi, updateGrievanceStatusApi } from "../../app/api";
import GrievanceCard from "./components/GrievanceCard";
import GrievanceForm from "./components/GrievanceForm";
import AdminGrievanceList from "./components/AdminGrievanceList";
import { 
  Plus, 
  List, 
  LayoutDashboard, 
  History,
  AlertCircle,
  Loader2
} from "lucide-react";
import toast from "react-hot-toast";
import { Filter, Search } from "lucide-react";

const GrievancePage = () => {
  const [grievances, setGrievances] = useState([]);
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState(null);
  const [view, setView] = useState("list"); // "list" | "form"
  const [openForm, setOpenForm] = useState(false);
  const [refresh, setRefresh] = useState(0);

  useEffect(() => {
    fetchInitialData();
  }, [refresh]);

  const fetchInitialData = async () => {
    try {
      setLoading(true);
      const [userRes, grievanceRes] = await Promise.all([
        getProfileApi(),
        getGrievancesApi()
      ]);

      if (userRes.success) setUser(userRes.data);
      if (grievanceRes.success) setGrievances(grievanceRes.data);
    } catch (err) {
      toast.error("Failed to load data");
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const isAdmin = user && [1, 2, 3].includes(user.role_id);

  const handleStatusAction = async (id, status, currentNote = "") => {
    try {
      let finalStatus = status;
      let finalNote = currentNote;

      // Handle employee satisfaction by appending to the note
      if (status === 'resolved_accepted') {
        finalStatus = 'resolved';
        finalNote = (currentNote || "") + " [RESOLVED_ACCEPTED]";
      }
      
      await updateGrievanceStatusApi(id, { 
        status: finalStatus,
        admin_note: finalNote
      });
      
      if (status === 'resolved_accepted') {
        toast.success("We're glad you're satisfied!");
      } else {
        toast.success(status === 'reopened' ? "Grievance reopened" : "Status updated");
      }
      
      setRefresh(prev => prev + 1);
    } catch (err) {
      toast.error(err.message || "Action failed");
    }
  };

  return (
    <div className="min-h-screen md:mt-[84px] pt-6 pb-6 rounded-[20px] px-4 md:px-8 bg-[#1b153f] text-white">
      <div className="max-w-7xl mx-auto">
        {/* HEADER */}
        {/* <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-6 mb-10">
          <div>
            <div className="flex items-center gap-2 mb-1">
              <span className="w-8 h-[2px] bg-indigo-500"></span>
              <span className="text-xs font-bold uppercase tracking-[0.3em] text-indigo-400">Support Center</span>
            </div>
            <h1 className="text-4xl md:text-5xl font-semibold tracking-tight text-white">
              Grievance <span className="text-white ">Management</span>
            </h1>
            <p className="text-slate-400 mt-2 max-w-lg">
              {isAdmin 
                ? "Oversee and resolve employee complaints through a transparent lifecycle." 
                : "Raise your concerns securely. Our management team is here to listen and help."}
            </p>
          </div>

          <div className="flex bg-slate-900/60 p-1.5 rounded-2xl border border-slate-800 backdrop-blur-xl">
            <button 
              onClick={() => setView("list")}
              className={`flex items-center gap-2 px-6 py-2.5 rounded-xl font-bold text-sm transition-all ${
                view === "list" 
                  ? "bg-indigo-600 text-white shadow-lg shadow-indigo-500/25" 
                  : "hover:bg-slate-800 text-slate-400"
              }`}
            >
              {isAdmin ? <LayoutDashboard size={18} /> : <History size={18} />}
              {isAdmin ? "" : "My Grievances"}
            </button>
            {!isAdmin && (
              <button 
                onClick={() => setView("form")}
                className={`flex items-center gap-2 px-6 py-2.5 rounded-xl font-bold text-sm transition-all ${
                  view === "form" 
                    ? "bg-indigo-600 text-white shadow-lg shadow-indigo-500/25" 
                    : "hover:bg-slate-800 text-slate-400"
                }`}
              >
                <Plus size={18} />
                New Complaint
              </button>
            )}
          </div>
        </div> */}

        {/* USER HEADER ONLY */}
{!isAdmin && (
  <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-6 mb-10">
    
    {/* <div>
      <div className="flex items-center gap-2 mb-1">
        <span className="w-8 h-[2px] bg-indigo-500"></span>
        <span className="text-xs font-bold uppercase tracking-[0.3em] text-indigo-400">
          Support Center
        </span>
      </div>

      <h1 className="text-4xl md:text-5xl font-semibold tracking-tight text-white">
        Grievance <span className="text-indigo-400">Management</span>
      </h1>

      <p className="text-slate-400 mt-2 max-w-lg">
        Raise your concerns securely. Our management team is here to listen and help.
      </p>
    </div> */}

<div className="flex items-center gap-4 mb-8">
            <div className="p-3 rounded-2xl bg-gradient-to-br from-blue-500 to-indigo-600">
              <Filter className="w-6 h-6 text-white" />
            </div>
            <div>
              <h1 className="text-2xl font-semibold">Grievance Management</h1>
              <p className="text-white/60 text-sm">
              Raise your concerns securely. Our management team is here to listen and help.
              </p>
            </div>
          </div>

    <div className="flex md:flex-row flex-col bg-slate-900/60 p-1.5 rounded-2xl border border-slate-800 backdrop-blur-xl mt-[-44px]">
      <button 
        onClick={() => setView("list")}
        className={`flex items-center gap-2 px-6 py-2.5 rounded-xl font-bold text-sm transition-all ${
          view === "list" 
            ? "bg-indigo-600 text-white shadow-lg shadow-indigo-500/25" 
            : "hover:bg-slate-800 text-slate-400"
        }`}
      >
        <History size={18} />
        My Grievances
      </button>

      <button 
        // onClick={() => setView("form")}
        onClick={() => setOpenForm(true)}
        className={`flex items-center gap-2 px-6 py-2.5 rounded-xl font-bold text-sm transition-all ${
          view === "form" 
            ? "bg-indigo-600 text-white shadow-lg shadow-indigo-500/25" 
            : "hover:bg-slate-800 text-slate-400"
        }`}
      >
        <Plus size={18} />
        New Complaint
      </button>
    </div>
  </div>
)}

        {/* CONTENT */}
        {loading ? (
          <div className="flex flex-col items-center justify-center py-32 space-y-4">
            <Loader2 size={48} className="text-indigo-500 animate-spin" />
            <p className="text-slate-500 font-medium animate-pulse">Initializing module...</p>
          </div>
        ) : (
          <div className="animate-in fade-in slide-in-from-bottom-4 duration-700">
            {view === "form" ? (
              <div className="max-w-2xl mx-auto">
                <GrievanceForm 
                  onSuccess={() => { setRefresh(prev => prev + 1); setView("list"); }} 
                  onCancel={() => setView("list")} 
                />
              </div>
            ) : (
              <>
                {isAdmin ? (
                  <AdminGrievanceList 
                    grievances={grievances} 
                    onRefresh={() => setRefresh(prev => prev + 1)} 
                    onAddNew={() => setOpenForm(true)}
                  />
                ) : (
                  // <div className="space-y-6">
                  <div className="max-w-7xl mx-auto md:mt-[-44px]">
  <div className="relative overflow-hidden rounded-[32px] p-6 md:p-8 bg-gradient-to-br from-[#1e174a] to-[#0f0c29] text-white border border-white/10 shadow-[0_40px_100px_-20px_rgba(0,0,0,0.7)]">

    {/* Glow effects (same as admin) */}
    <div className="absolute -top-24 -right-24 w-96 h-96 bg-blue-600/20 blur-[100px]" />
    <div className="absolute -bottom-24 -left-24 w-96 h-96 bg-purple-600/20 blur-[100px]" />

    <div className="relative z-10 space-y-6"></div>
                    {grievances.length > 0 ? (
                      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                        {grievances.map((grievance) => (
                          <GrievanceCard 
                            key={grievance.id} 
                            grievance={grievance} 
                            onAction={(id, status) => handleStatusAction(id, status, grievance.admin_note)}
                            isAdmin={false}
                          />
                        ))}
                      </div>
                    ) : (
                      <div className="text-center py-24 bg-slate-900/30 rounded-[32px] border border-dashed border-slate-800">
                        <div className="w-16 h-16 bg-slate-800/50 rounded-full flex items-center justify-center mx-auto mb-4">
                          <AlertCircle size={32} className="text-slate-600" />
                        </div>
                        <h3 className="text-xl font-bold text-slate-300">Clean Slate!</h3>
                        <p className="text-slate-500 mt-1 mb-8 max-w-xs mx-auto text-sm">
                          You haven't raised any grievances yet. If something is on your mind, we're here to help.
                        </p>
                        <button 
                          onClick={() => setView("form")}
                          className="bg-indigo-600 hover:bg-indigo-500 text-white font-bold px-8 py-3 rounded-2xl transition-all shadow-xl shadow-indigo-600/10"
                        >
                          Submit New Grievance
                        </button>
                      </div>
                    )}
                  </div>

                  </div>
                )}
              </>
            )}
          </div>
        )}
      </div>



      {openForm && (
  <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 backdrop-blur-sm">

    {/* CLICK OUTSIDE CLOSE */}
    <div
      className="absolute inset-0"
      onClick={() => setOpenForm(false)}
    />

    {/* MODAL CONTENT */}
    <div
      className="relative z-10 w-full max-w-3xl px-4 animate-in fade-in zoom-in-95 duration-300"
      onClick={(e) => e.stopPropagation()}
    >
      <GrievanceForm
        onSuccess={() => {
          setOpenForm(false);
          setRefresh(prev => prev + 1);
        }}
        onCancel={() => setOpenForm(false)}
      />
    </div>
  </div>
)}
    </div>
  );
};

export default GrievancePage;
